"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var intl_format_1 = require("@biw/intl-format");
var propTypes = {
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    locale: prop_types_1.default.oneOfType([
        prop_types_1.default.shape({ code: prop_types_1.default.string, intlCode: prop_types_1.default.string }),
        prop_types_1.default.string
    ]),
    dispatch: prop_types_1.default.any,
    TextComponent: prop_types_1.default.any,
    formatOptions: prop_types_1.default.shape({})
};
var defaultProps = {
    locale: 'en-US',
    TextComponent: 'span',
    formatOptions: {}
};
var isValid = function (value) { return typeof value === 'number' || typeof value === 'string'; };
var FormattedNumber = function (_a) {
    var value = _a.value, locale = _a.locale, formatOptions = _a.formatOptions, TextComponent = _a.TextComponent, dispatch = _a.dispatch, props = tslib_1.__rest(_a, ["value", "locale", "formatOptions", "TextComponent", "dispatch"]);
    return (react_1.default.createElement(TextComponent, tslib_1.__assign({}, props), isValid(value) && intl_format_1.formatNumber(locale, formatOptions, value)));
};
FormattedNumber.defaultProps = defaultProps;
FormattedNumber.propTypes = propTypes;
exports.default = FormattedNumber;
//# sourceMappingURL=formatted-number.js.map